var map = {
  "./SectionObserver": [
    "3459",
    "168"
  ],
  "./Timeline.ts": [
    "1339",
    "545",
    "696"
  ],
  "./AbstractSwiper.ts": [
    "6446",
    "545",
    "187"
  ],
  "./widgets": [
    "6535"
  ],
  "./CustomSwiper": [
    "8623",
    "545",
    "572"
  ],
  "./PostCardSwiper.ts": [
    "6264",
    "545",
    "521"
  ],
  "./HeaderAnimation": [
    "363",
    "545",
    "592"
  ],
  "./Products": [
    "112",
    "417"
  ],
  "./CustomSwiper.ts": [
    "8623",
    "545",
    "572"
  ],
  "./SectionObserver.ts": [
    "3459",
    "168"
  ],
  "./AbstractSwiper": [
    "6446",
    "545",
    "187"
  ],
  "./Timeline": [
    "1339",
    "545",
    "696"
  ],
  "./VideoFeature.ts": [
    "9687",
    "545",
    "92"
  ],
  "./definition": [
    "4389"
  ],
  "./ImageScroller": [
    "253",
    "545",
    "966"
  ],
  "./DummyClass": [
    "2920",
    "929"
  ],
  "./definition.ts": [
    "4389"
  ],
  "./ImageScroller.ts": [
    "253",
    "545",
    "966"
  ],
  "./HeaderAnimation.ts": [
    "363",
    "545",
    "592"
  ],
  "./ImageSwiper": [
    "9387",
    "545",
    "936"
  ],
  "./Navigation": [
    "582",
    "675"
  ],
  "./PostCardSwiper": [
    "6264",
    "545",
    "521"
  ],
  "./VideoFeature": [
    "9687",
    "545",
    "92"
  ],
  "./DummyClass.ts": [
    "2920",
    "929"
  ],
  "./Products.ts": [
    "112",
    "417"
  ],
  "./ImageSwiper.ts": [
    "9387",
    "545",
    "936"
  ],
  "./widgets.ts": [
    "6535"
  ],
  "./FeaturesAnimations.ts": [
    "8020",
    "545",
    "149"
  ],
  "./FeaturesAnimations": [
    "8020",
    "545",
    "149"
  ],
  "./Navigation.ts": [
    "582",
    "675"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 5985;
module.exports = __rspack_async_context;
